import MonthChart from "./Month";
import YearChart from "./Year";

import styles from "@styles/containers/cdp/audiences.module.scss";

export default function Charts({ days, months }) {
  return (
    <div className={styles.charts}>
      <MonthChart data={days} />
      <YearChart data={months} />
    </div>
  );
}
